<div class="two-factor-form">
  <form (ngSubmit)="submitForm()">
    <h2 mat-dialog-title>{{ isBackup ? ('account.dialogs.mfa.signIn.enterBackupCode' | t) : ('account.dialogs.mfa.signIn.enterOtpCode' | t) }}</h2>
    <mat-dialog-content class="mat-typography">
      <sn-alert dense class="auth-rounded-1" type="danger" *ngIf="otpForm.errors || backupForm.errors">
        <div *ngFor="let error of otpForm.errors | keyvalue">
          <b>{{ toStartCase(error.key) }}</b
          >: {{ error.value }}
        </div>
        <div *ngFor="let error of backupForm.errors | keyvalue">
          <b>{{ toStartCase(error.key) }}</b
          >: {{ error.value }}
        </div>
      </sn-alert>
      <ng-container *ngIf="isBackup; else otpTmpl">
        <sn-form [form]="backupForm" [fields]="backupField" [model]="formModel"></sn-form>
      </ng-container>
      <ng-template #otpTmpl>
        <p>{{ 'account.dialogs.mfa.signIn.otpInstructions' | t }}</p>
        <sn-form [form]="otpForm" [fields]="otpField" [model]="formModel"></sn-form>
      </ng-template>
      <span class="backupCode" (click)="useBackupCodes()">{{
      !isBackup ? ('account.dialogs.mfa.signIn.wantToUseBackupCode' | t) : ('account.dialogs.mfa.signIn.useOtpCode' | t)
      }}</span>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button color="warn" mat-dialog-close>{{ 'common.cancel' | t }}</button>
      <button
        mat-button
        *ngIf="isBackup"
        [mtBasicSpinner]="isLoading"
        [disabled]="backupForm.invalid"
        color="success"
        type="submit"
      >
        {{ 'common.submit' | t }}
      </button>
      <button
        mat-button
        *ngIf="!isBackup"
        [mtBasicSpinner]="isLoading"
        [disabled]="otpForm.invalid"
        color="success"
        type="submit"
      >
        {{ 'common.submit' | t }}
      </button>
    </mat-dialog-actions>
  </form>
</div>
